export interface ClientConfigType {
  AUTH_DOMAIN: string;
  AUTH_CLIENT_ID: string;
  MAINTENANCE_MODE: boolean;
}

const ClientConfig: ClientConfigType = {
  AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN || 'ev-gs4k8idk.us.auth0.com',
  AUTH_CLIENT_ID:
    import.meta.env.VITE_AUTH_CLIENT_ID || 'EIce1PtRTya8ZMsIPLesHYOKefZe0I2e',
  MAINTENANCE_MODE: Boolean(import.meta.env.VITE_MAINTENANCE_MODE) ?? false,
};

Object.freeze(ClientConfig);

export default ClientConfig;
